import {
  useCreateDealerDomainMutation,
  useDeleteDealerDomainMutation,
} from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { useTranslation } from "react-i18next";

export const useManagementDomains = () => {
  const { t } = useTranslation();
  const [addNotificationMutation] = useAddNotificationMutation({});

  const [createDomain] = useCreateDealerDomainMutation({
    onCompleted() {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.success,
          content: t("common.сhange_was_successful"),
        },
      });
    },
    onError(value) {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.error,
          content: value["message"],
        },
      });
    },
  });

  const [deleteDomain] = useDeleteDealerDomainMutation({
    onCompleted() {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.success,
          content: t("common.сhange_was_successful"),
        },
      });
    },
    onError(vals) {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.error,
          content: vals["message"],
        },
      });
    },
  });

  return { createDomain, deleteDomain };
};
